import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './ImageA.module.scss';

const ImageA = (props) => {
  const {
    url,
    altText = '',
    className,
    height,
    width,
  } = props;

  return (
    (url &&
      <div className={classNames(classes.imageWrapper, className)}>
        <img
          src={url}
          alt={altText}
          width={width}
          height={height}
          loading='lazy'
        />
      </div>) || null
  );
};

ImageA.propTypes = {
  altText: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default ImageA;
